var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 117.235 129.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(-1544.308 -532.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M1628.264,532.705c0,.951.007,1.723.009,2.493q.047,12.318.1,24.637c.024,4.224,1.479,5.678,5.664,5.67q12.318-.027,24.637-.088c.775,0,1.55-.006,2.554-.01.048.916.123,1.67.126,2.426q.107,26.029.193,52.058c.025,10.6-6.894,17.552-17.519,17.6q-28.922.138-57.842.218c-10.6.03-17.642-6.909-17.695-17.476q-.17-35.027-.26-70.052c-.023-8.509,4.79-14.973,12.592-16.962a16.885,16.885,0,0,1,4.025-.462q20.888-.126,41.775-.174C1627.039,532.585,1627.46,532.646,1628.264,532.705Zm-13.447,56.83v-.022c6.07-.024,12.139.013,18.207-.1a4.324,4.324,0,0,0,4.363-4.357,4.52,4.52,0,0,0-4.08-4.475,15.07,15.07,0,0,0-2.137-.077q-13.925.043-27.849.1c-2.07.009-4.144-.044-6.211.054-2.591.122-4.234,1.527-4.546,3.711-.438,3.057,1.387,5.182,4.687,5.208C1603.1,589.629,1608.962,589.558,1614.817,589.535Zm.27,15.142v-.027c-2.142.008-4.284.013-6.426.026-3.927.02-7.857-.048-11.78.1a4.33,4.33,0,0,0-4.112,5.837c.561,1.87,2.353,3.045,4.891,3.067,3.711.031,7.425-.014,11.138-.028q11.246-.042,22.492-.087a15.2,15.2,0,0,0,2.136-.1,4.492,4.492,0,0,0,4.043-4.5,4.308,4.308,0,0,0-4.389-4.327C1627.084,604.573,1621.085,604.654,1615.087,604.677Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M1559.267,557.048c0,.978.006,1.816.009,2.654.077,20.209.1,40.419.248,60.627.08,11.282,5.222,19.477,15.494,24.287a25.74,25.74,0,0,0,11.26,2.09q24.209-.144,48.417-.2l2.524-.009c.162,5.645-4.329,11.889-10.2,13.9a22.159,22.159,0,0,1-6.91,1.1q-29.028.231-58.057.253c-10.41.019-17.382-6.877-17.432-17.22-.114-23.422-.1-46.846-.312-70.267C1544.213,563.919,1551.92,557.632,1559.267,557.048Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M1637.463,556.384c-.025-6.906-.051-13.7-.076-20.327l20.349,20.252Z",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFilled);
export default __webpack_public_path__ + "static/media/copyFilled.40e4ea2a1159d709c36851fe616c957f.svg";
export { ForwardRef as ReactComponent };